import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  Button,
  Card,
  Form,
  InputGroup,
  Row,
  Col,
} from "react-bootstrap";

import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
  Filter,
} from "react-bs-datatable";
import {
  deleteMTE,
  getMTE,
  importExcel,
} from "../../../../services/MTEService";

const MTEList = () => {
  const [mtes, setMTE] = useState([]);
  const [filterText, setFilterText] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setMessage(""); // Clear previous messages
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await importExcel(formData);
      setMessage(response);
    } catch (error) {
      console.error("Upload error:", error);
      setMessage("Error uploading file.");
    }
  };

  useEffect(() => {
    getMTE()
      .then((data) => setMTE(data))
      .catch((error) => console.error(error));
  }, []);

  const onDelete = (id) => {
    deleteMTE(id)
      .then(() => setMTE(mtes.filter((mte) => mte._id !== id)))
      .catch((error) => console.error(error));
  };

  // Table header configuration for Datatable
  const header = [
    { prop: "employee", title: "Employee" },
    { prop: "manager", title: "Manager" },
    { prop: "contract", title: "Contract" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link to={`/settings/mte/edit/${row._id}`}>
            <Button
              style={{ border: "0px" }}
              variant="warning"
              title="Edit"
              className="btn btn-primary bg-primary btn-xs sharp me-1"
            >
              <i className="fa fa-pencil"></i>
            </Button>
          </Link>
          <Button
            onClick={() => onDelete(row._id)}
            title="Delete"
            className="btn btn-danger shadow btn-xs sharp"
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format the data for Datatable
  const tableData = mtes.map((mte) => ({
    employee: mte.employee,
    manager: mte.manager,
    contract: mte.contract,
    _id: mte._id, // Needed for actions
  }));

  return (
    <div>
      <Card>
        <Card.Body>
          <h1>List of MTE</h1>
          <Row className="mb-4">
            <Col md={3} lg={3}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Form.Control
                type="text"
                placeholder="Search by Job Title"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
            <Col md={7} lg={7} >
              <Form className="d-flex align-items-center">
                <Form.Group controlId="formFile" className="mb-0 mr-2">
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "inline-block", width: "auto" }}
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  onClick={handleUpload}
                  className="ml-2"
                  style={{marginLeft: "5px", marginRight: "5px"}}
                >
                  Upload
                </Button>
                {message && <span className="" style={{"marginLeft": "10px"}}>{message}</span>}
              </Form>
             
            </Col>
            <Col md={2} lg={2} className="d-flex justify-content-end">
              <Link to="/settings/mte/add">
                <Button variant="primary">Add MTE</Button>
              </Link>
            </Col>
          </Row>

          <DatatableWrapper
            body={tableData.filter((item) =>
              item.employee.toLowerCase().includes(filterText.toLowerCase())
            )}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15],
              },
            }}
          >
            <Table>
              <TableHeader />
              <TableBody />
            </Table>
            <Row>
              <Col className="d-flex flex-col justify-content-start">
                <PaginationOptions />
              </Col>
              <Col>
                <Filter
                  classes={{
                    inputGroup: "input-group-classname",
                    input: "input-classname",
                    clearButton: "clear-button-classname",
                  }}
                />
              </Col>
              <Col className="mt-4">
                <Pagination />
              </Col>
            </Row>
          </DatatableWrapper>
        </Card.Body>
      </Card>
    </div>
  );
};

export default MTEList;
